import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getPurchaseOrder,
  getPurchaseOrderById,
  getParticularPage,
  getSaleOrderDetail,
  getNext,
  getPrevious,
  handleSearch,
  getPurchaseOrderAdditionalChargeList,
  getPurchaseOrderChargeStatus,
  createPurchaseOrder,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";

const initialState = {
  purchaseOrders: [],
  edit: false,
  purchaseOrder: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingPurchaseOrder: false,
  loadingNext: false,
  loadingDetails: false,
  saveAndContinue: false,
  purchaseOrderDetails: [
    {
      product: null,
      vendor: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate()),
      unique: uuidv4(),
    },
  ],
  additionalCharges: null,
  hasAdditionalCharges: false,
  showCreateModal: false,

  formData: {
    partyAccount: null,
    branch: null,
    orderNo: "",
    purchaseFromBranch: null, // this used in order summary
    voucherDateBs: new NepaliDate(),

    refNo: "",
    narration: "",
    discountAmount: "",
    grandTotal: "",
    vatAmount: "",
    documentsAttach: [],
    purchaseOrderMainPartyDetails: {
      // *removed
      // creditDays: "",
      // jobNumber: "",
      // partyAccount: null,
    },
    purchaseOrderMainVehicleDetail: {
      vehicleNo: "",
      builtyNo: "",
      driverName: "",
      driverPhoneNo: "",
      driverAddress: "",
      licenseNo: "",
      transporter: "",
      quantity: "",
    },
  },
};

export const purchaseOrderSlice = createSlice({
  name: "purchaseOrder",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    updatedAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },
    purchaseOrderDetailsUpdated: (state, action) => {
      const sam = action.payload?.reduce((acc, pos) => {
        return Number(pos.actualQuantity) + acc;
      }, 0);
      state.purchaseOrderDetails = action.payload;
      state.additionalCharges = state?.additionalCharges?.map((value) => {
        return { ...value, amount: value.canEdit ? value.rate * sam : value.amount };
      });
    },

    clearPurchaseOrderDetails: (state) => {
      state.purchaseOrderDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
        },
      ];
    },
    clearAllPurchaseOrder: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingPurchaseOrder = false;
      state.purchaseOrder = null;
      state.saveAndContinue = false;
      state.purchaseOrderDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
        },
      ];
      state.hasAdditionalCharges = false;
      state.additionalCharges = null;
      state.formData = initialState.formData;
    },

    savePurchaseOrderForm: (state, action) => {
      state.formData = action.payload;
    },
    resetPurchaseOrderForm: (state, action) => {
      if (action.payload) {
        state.formData = state.purchaseOrder;
      } else {
        state.formData = initialState.formData;
        state.purchaseOrderDetails = initialState.purchaseOrderDetails;
        // state.purchaseOrderDetails = initialState.purchaseOrderDetails;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createPurchaseOrder.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createPurchaseOrder.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createPurchaseOrder.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getPurchaseOrderChargeStatus.pending, (state) => {
      state.hasAdditionalCharges = false;
    });
    builder.addCase(getPurchaseOrderChargeStatus.fulfilled, (state, action) => {
      state.hasAdditionalCharges = action.payload.data.length > 0 ? true : false;
    });
    builder.addCase(getPurchaseOrderChargeStatus.rejected, (state) => {
      state.hasAdditionalCharges = null;
    });
    builder.addCase(getPurchaseOrderAdditionalChargeList.pending, (state) => {
      state.additionalCharges = null;
    });
    builder.addCase(getPurchaseOrderAdditionalChargeList.fulfilled, (state, action) => {
      state.additionalCharges = action.payload.data;
    });
    builder.addCase(getPurchaseOrderAdditionalChargeList.rejected, (state) => {
      state.additionalCharges = null;
    });
    // get
    builder.addCase(getSaleOrderDetail.pending, (state) => {
      state.loadingDetails = true;
      state.purchaseOrderDetails = null;
    });
    builder.addCase(getSaleOrderDetail.fulfilled, (state, action) => {
      state.loadingDetails = false;
      state.purchaseOrderDetails = action.payload.data;
    });
    builder.addCase(getSaleOrderDetail.rejected, (state) => {
      state.loadingDetails = false;
      state.purchaseOrderDetails = null;
    });
    // getPurchaseOrderById
    builder.addCase(getPurchaseOrderById.pending, (state) => {
      state.loading = true;
      state.purchaseOrder = null;
    });
    builder.addCase(getPurchaseOrderById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.purchaseOrder = action.payload.data;
      state.purchaseOrderDetails = action.payload.data?.purchaseOrderDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
      state.additionalCharges = action.payload.data?.purchaseOrderMainAdditionalChargeCost;

      // const main = action.payload.data?.purchaseReturnBranchMain || {};
      state.formData = {
        ...action.payload.data,
      };
      // purchaseReturnBranchMainVehicleDetail: {
      //   vehicleNo: main.purchaseReturnBranchMainVehicleDetail?.vehicleNo || "",
      //   builtyNo: main.purchaseReturnBranchMainVehicleDetail?.builtyNo || "",
      //   driverName: main.purchaseReturnBranchMainVehicleDetail?.driverName || "",
      //   driverPhoneNo: main.purchaseReturnBranchMainVehicleDetail?.driverPhoneNo || "",
      //   driverAddress: main.purchaseReturnBranchMainVehicleDetail?.driverAddress || "",
      //   licenseNo: main.purchaseReturnBranchMainVehicleDetail?.licenseNo || "",
      //   transporter: main.purchaseReturnBranchMainVehicleDetail?.transporter || "",
      //   quantity: main.purchaseReturnBranchMainVehicleDetail?.quantity || "",
      // },
      // };
    });
    builder.addCase(getPurchaseOrderById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.purchaseOrder = null;
    });
    builder.addMatcher(
      isAnyOf(
        getPurchaseOrder.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingPurchaseOrder = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getPurchaseOrder.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingPurchaseOrder = false;
        state.purchaseOrders = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPurchaseOrder.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingPurchaseOrder = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  updatedAdditionalCharges,
  purchaseOrderDetailsUpdated,
  clearPurchaseOrderDetails,
  clearAllPurchaseOrder,
  savePurchaseOrderForm,
  resetPurchaseOrderForm,
} = purchaseOrderSlice.actions;

export default purchaseOrderSlice.reducer;
